import styles from './TabNav.module.scss';
import React, { useState, useEffect, useRef } from 'react';

export interface TabNavProps {
	primaryRadio?: string;
	secondaryRadio?: string;
}

export const TabNav: React.FC<TabNavProps> = ({ primaryRadio, secondaryRadio }) => {
	const [elementStyle, setElementStyle] = useState({
		width: undefined,
		left: undefined,
	});
	const checkboxRef = useRef(null);

	const [isChecked, setIsChecked] = useState(true);

	useEffect(() => {
		// Add checked on pageload
		setIsChecked((prev) => prev);
		setTimeout(() => {
			setElementStyle({
				width: checkboxRef.current.clientWidth,
				left: 0,
			});
		}, 500);
	}, [isChecked]);

	const onClick = (e) => {
		// Remove checked when clicked. The check will be handled by input
		setIsChecked(!isChecked);
		if (e.target.previousSibling) {
			setElementStyle({
				width: e.target.nextSibling.clientWidth,
				// Adding 60px to compensate for margin-right: 6rem
				left: e.target.previousSibling.clientWidth + 60,
			});
		} else {
			setElementStyle({
				width: e.target.nextSibling.clientWidth,
				left: 0,
			});
		}
	};
	return (
		<section className={styles.TabNav}>
			<div className={styles.TabNav_TabNavTabs}>
				<input
					value={primaryRadio}
					className={styles.TabNav_TabNavInput}
					onChange={onClick}
					type="radio"
					id="radio-1"
					name="tabs"
					checked={isChecked}
				/>
				<label className={styles.TabNav_TabNavTab} htmlFor="radio-1" ref={checkboxRef}>
					{primaryRadio}
				</label>
				<input value={secondaryRadio} className={styles.TabNav_TabNavInput} onChange={onClick} type="radio" id="radio-2" name="tabs" />
				<label className={styles.TabNav_TabNavTab} htmlFor="radio-2">
					{secondaryRadio}
				</label>
				<span className={styles.TabNav_TabNavGlider} style={{ width: elementStyle.width, left: elementStyle.left }}></span>
			</div>
		</section>
	);
};
